const fontWeights = {
  light: 400,
  medium: 500,
  heavy: 600,
};

export default fontWeights;
